import React, { Component } from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import classnames from 'classnames';
import styles from './styles.module.css';

import BackgroundImage from '../../components/background-image';
import GridWrap from '../../components/grid-wrap';
import GridRow from '../../components/grid-row';
import GridCol from '../../components/grid-col';
import TileLink from '../../components/tile-link';
import SubHeading from '../../components/sub-heading';
import ContributionForm from '../../components/contribution-form';
import SiteFooter from '../../components/site-footer';

import RoomImage from '../../images/room.jpg';
import TileOneImage from '../../images/tile-one.jpg';
import TileTwoImage from '../../images/tile-two.jpg';

export default class Contribute extends Component {
  state = {
    contributingOpen: false,
    contributingForm: null,
  };

  openContributing = view =>
    this.setState({ contributingOpen: true, contributingForm: view });
  closeContributing = view =>
    this.setState({ contributingOpen: false, contributingForm: null });

  render() {
    return (
      <div>
        <Helmet title="Contribute" />
        <div className={styles.container}>
          <div>
            <BackgroundImage height={540} src={RoomImage} />
            <div className={styles.top}>
              <GridWrap>
                <div className={styles.topContent}>
                  <h1>Contribute</h1>
                  <p>
                    Sharing your knowledge of Whitefriars glass, or your
                    memories of the Whitefriars Factory, will help to improve
                    everyone’s understanding of the Whitefriars they know, or
                    have.
                  </p>
                  <p>
                    Here you can share your own knowledge and search for other
                    similar pieces or windows, as well as read the memories of
                    those who worked in the Factory.
                  </p>
                </div>
              </GridWrap>
            </div>
          </div>
          <GridWrap>
            <div className={styles.content}>
              <div className={styles.intro}>
                <SubHeading text="Find out how" />
                <p>
                  All you need to do is select the type of entry you’d like to
                  make, and complete the form in as much detail as possible. The
                  more you can fill out the better, but if you don’t have access
                  to part of the information don’t worry. The more contributions
                  we get the more complete picture we can build. If you can
                  upload relevant, high quality images, then please upload them
                  as PNG. or JPG. files.
                </p>
                <p>
                  Headstone Manor and Museum, is unable to offer valuations on
                  any pieces and as such we have not included this as an
                  available field in the contribution form. All submissions will
                  be moderated before being added to the database.
                </p>
                <p>Use the links below to get started on your contribution.</p>
              </div>
              <div className={styles.linkSection}>
                <GridRow>
                  <GridCol>
                    <SubHeading text="Get started" />
                  </GridCol>
                  <GridCol>
                    <div className={styles.links}>
                      <div className={styles.link}>
                        <TileLink
                          to="/glass"
                          imageSrc={TileOneImage}
                          title="Existing Items"
                          text="Check out the Whitefriars Glass we already have documented and see if you have anything to add."
                        />
                      </div>
                      <div className={styles.link}>
                        <TileLink
                          id="open-new-item"
                          onClick={() => this.openContributing('newItem')}
                          imageSrc={TileTwoImage}
                          title="Add New Items"
                          text="Add a new item of Whitefriars Glass that we don't yet have on the website."
                        />
                      </div>
                      <div className={styles.link}>
                        <TileLink
                          onClick={() => this.openContributing('memory')}
                          imageSrc={TileOneImage}
                          title="Add A Memory"
                          text="Add one of your personal memories or stories related to Whitefriars or its products."
                        />
                      </div>
                    </div>
                  </GridCol>
                </GridRow>
              </div>
            </div>
          </GridWrap>
        </div>

        {this.state.contributingOpen && (
          <ContributionForm
            form={this.state.contributingForm}
            closeForm={this.closeContributing}
          />
        )}

        <SiteFooter />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/page-components/contribute/index.js